import styles from './style.module.scss';
import { Descriptions, Space, Spin, Col, Badge } from 'antd';
import { Button, PageHeader } from 'components';
import { Link } from 'react-router-dom';
import { DownloadOutlined } from '@ant-design/icons';
import { EditIcon } from 'icons';
import { useTranslation } from 'react-i18next';
import useDocuments from '../useInvoiceMonthlies';

const Single = () => {
  const { t } = useTranslation();
  const { singleItem, handleDownloadPdf, statusTexts, statusColors } =
    useDocuments(false);

  const title = t('FATTURATI MENSILE');

  return singleItem ? (
    <div>
      <PageHeader title={title}>
        <Col>
          <Link to={'edit'}>
            <Button icon={<EditIcon />} type={'secondary'} big>
              {t('MODIFICA')}
            </Button>
          </Link>
        </Col>
      </PageHeader>
      <div className={styles.content}>
        <Descriptions column={1} bordered>
          <Descriptions.Item label={t('Insegna')}>
            {singleItem.allData?.invoice_year?.company?.name}
          </Descriptions.Item>
          <Descriptions.Item label={t('Data caricamento')}>
            {singleItem.period}
          </Descriptions.Item>
          <Descriptions.Item label={t('Stato')}>
            <Badge
              color={statusColors[singleItem.allData?.invoice_year?.status]}
              text={statusTexts[singleItem.allData?.invoice_year?.status]}
            />
          </Descriptions.Item>
          <Descriptions.Item label={t('File')}>
            <Space>
              <Button
                type={'primary-white'}
                icon={<DownloadOutlined />}
                onClick={() =>
                  handleDownloadPdf(
                    singleItem.allData?.invoice_year?.file.url,
                    singleItem.allData?.invoice_year?.file.file_name
                  )
                }
              >
                Scarica file
              </Button>
              <Button
                type={'primary-white'}
                icon={<DownloadOutlined />}
                onClick={() =>
                  handleDownloadPdf(
                    singleItem.allData?.invoice_year?.document.url,
                    singleItem.allData?.invoice_year?.document.file_name
                  )
                }
              >
                Scarica file PDF
              </Button>
            </Space>
          </Descriptions.Item>
        </Descriptions>
      </div>
    </div>
  ) : (
    <Spin size={'large'} />
  );
};

export default Single;
